import Vue from 'vue';
import Vuex from 'vuex';

import { Message } from 'element-ui';

/**
 * 各个模块
 */
// 用户模块
import user from './modules/user';
// 导航模块
import navigation from './modules/navigation';
// 小标签
// import tagsView from './modules/tagsView';
// 公共数据字典
import dataDictionary from './modules/data-dictionary';

/**
 * api
 */
import { getAppList, getOssToken } from '@/api/index';

const state = {
  sideBarOpened: true,
  appSystemList: [], // app list 列表
  currentAppCode: '', // 当前应用系统
  currentClientId: '', // 当前应用系统ClientId
  ossConfig: {} // oss配置信息
};

const actions = {
  /**
   * 显示提示 msg.type 类型  msg.data 消息内容
   * @param commit
   * @param msg
   */
  showMessage({ commit }, msg) {
    Message({
      type: msg.type || 'info',
      message: msg.data || msg.message,
      duration: msg.duration !== undefined ? msg.duration : 3000
    });
  },
  /**
   * 更新当前appCode
   * @param commit
   * @param msg
   */
  updataAppCode({ commit, dispatch }, code) {
    commit('UPDATE_APP_CODE', code);
    dispatch('updateSideBarNav', code);
  },
  /**
   * 获取系统应用列表数据
   * @param commit
   * @param msg
   */
  getAppSystemList({ commit, state }) {
    return new Promise(resolve => {
      getAppList().then(res => {
        state.appSystemList = res.body || [];
        resolve(state.appSystemList);
      });
    });
  },
  /**
   * 获取oss config参数用于文件上传
   * @param state
   * @param commit
   * @constructor
   */
   getAwsOssToken({ state, commit }) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      // 判断是否存在且未过期
      const configTime = state.ossConfig.time || null;
      const nowTime = Number(new Date());
      // 有可用oss config则直接返回
      if (+nowTime < +configTime) {
        const { time, ...config } = state.ossConfig;
        resolve({
          ...config,
        });
        return;
      }
      await getOssToken()
        .then((res) => {
          const data = res.body || {};
          const { time, ...others } = data;
          resolve({
            ...others,
          });
          commit("UPDATE_OSS_TOKEN", data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};

const mutations = {
  /*
    清appCode
  */
  CLEAR_APPCODE(state) {
    state.currentAppCode = '';
  },

  /**
   * 更新侧边栏展开收起状态
   * @param state
   * @param boolean
   * @constructor
   */
  UPDATE_SIDEBAR_STATE(state, boolean) {
    state.sideBarOpened = !!boolean;
  },
  /**
   * 更新当前系统APP CODE
   * @param satte
   * @param code
   * @constructor
   */
  UPDATE_APP_CODE(state, code) {
    state.currentAppCode = code;
  },
  /**
   * 更新当前系统APP CLIENT ID
   * @param satte
   * @param code
   * @constructor
   */
  UPDATE_APP_CLIENT_ID(state, code) {
    state.currentClientId = code;
  },
  /**
   * 更新当前oss config信息
   * @param satte
   * @param data
   * @constructor
   */
  UPDATE_OSS_TOKEN(state, data) {
    state.ossConfig = { ...data };
  }
};

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  actions,
  mutations,
  modules: {
    // 用户模块
    user,
    // 导航模块
    navigation,
    dataDictionary
    // tagsView
  }
});
